import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { environment } from '../../../environments/environment';
import { displayImg } from '../utils/utils.functions';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../image-dialog/image-dialog.component';

@Component({
  selector: 'app-custom-dragdrop-image',
  templateUrl: './custom-dragdrop-image.component.html',
  styleUrl: './custom-dragdrop-image.component.scss',
})
export class CustomDragdropImageComponent implements OnInit, OnChanges {
  image: File;
  @Input() url: any[] = [];
  @Input() isDeletble: boolean = false;
  @Input() forProfile: boolean = false;
  @Output() sendImage = new EventEmitter<any>();
  @Input() text1: string = ' Glissez vos photos ici ou';
  @Input() text2: string = 'Parcourir vos fichiers';
  @Input() text3: string = 'Ajouter';
  @Input() icon: string = '/assets/icons/images.svg';
  @Input() width: string = '90px';
  @Input() imageContainerWidth: string = '';
  @Input() height: string = '72px';
  @Input() innerClass: string = 'rounded border border-1 p-2';
  @Input() smallInput: boolean = false;
  @Input() singleImage: boolean = true;
  @Input() messageError = '';
  @Input() limit = 0;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.url = this.url?.filter((el) => el != '');
  }
  ngOnChanges(changes: SimpleChanges) {}

  // fileBrowseHandler(EventEmitter): void {
  //   // this.file = EventEmitter[0];
  //   this.onImageSelection(EventEmitter);
  // }
  async onImageSelection(event: any) {
    this.messageError = '';
    if (event.target.files && event.target.files.length) {
      if (this.limit) {
        if (this.url?.filter(el => !!el)?.length + event.target.files.length > this.limit) {
          this.messageError = `Vous avez dépassé la limite de fichier (max. ${this.limit})  `;
          return;
        }
      }

      const files = Array.from(event.target.files);
      if (this.forProfile) {
        if (event.target.files.length) {
          for await (const item of files) {
            this.uploadImg(item);
          }
          setTimeout(() => {
            this.sendImage.emit(event.target.files[0]);
          }, 100);
          this.image = event.target.files[0];
        }
      } else {
        if (event.target.files.length) {
          for await (const item of files) {
            this.uploadImg(item);
          }
          setTimeout(() => {
            this.sendImage.emit(this.url);
          }, 100);
          this.image = event.target.files[0];
        }
      }
    }
  }
  uploadImg(item: any) {
    const reader = new FileReader();
    reader.readAsDataURL(<Blob>item); // read file as data url
    reader.onload = (event) => {
      // called once readAsDataURL is completed
      // @ts-ignore
      let img = event.target?.result.substring(23, event.target?.result.length);
      this.url = this.replaceFirstNullOrAppend(this.url, img)
    };
  }
  openImage(img: any) {
    const dialog = this.dialog.open(ImageDialogComponent, {
      backdropClass: 'bg-transparent',
      data: img,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
      }
    });
  }

  deleteImage(index: number): void {
    // this.url = this.url.filter((_, key) => key != index);
    this.url = this.replaceAtIndex(this.url, index, null);
    if (this.forProfile) {
      this.url = this.url.filter((_, key) => key != index);
    }
    this.sendImage.emit(this.url);
    this.messageError = '';
  }

  replaceAtIndex<T>(arr: T[], index: number, newValue: T): T[] {
    if (index < 0 || index >= arr.length) {
        throw new Error("Index out of bounds");
    }
    const newArr = [...arr];
    newArr[index] = newValue;
    return newArr;
}

 replaceFirstNullOrAppend<T>(arr: (T | null)[], newValue: T): (T | null)[] {
    const index = arr.indexOf(null);
    const newArr = [...arr];

    if (index !== -1) {
        newArr[index] = newValue;
    } else {
        newArr.push(newValue);
    }

    return newArr;
}

  protected readonly environment = environment;
  protected readonly displayImg = displayImg;
}
